import type { ReactNode } from 'react'

interface PageHeaderProps {
  /** Small gold line above the title, e.g. "Your agent". */
  kicker?: ReactNode
  title: ReactNode
  description?: ReactNode
  /** Controls set to the right of the title on wide screens, below it on phones. */
  actions?: ReactNode
}

/**
 * The top of every dashboard page: a kicker, the title in the display face and
 * an optional line of context, the way the front page sets its sections.
 */
export function PageHeader({ kicker, title, description, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0 space-y-2.5">
        {kicker ? <p className="bl-kicker">{kicker}</p> : null}
        <h1 className="bl-title">{title}</h1>
        {description ? <p className="max-w-2xl text-sm leading-relaxed text-[color:var(--bl-ink-2)]">{description}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  )
}
